'use client';

import { useOnMount } from '@base-ui/utils/useOnMount';
import { useIsoLayoutEffect } from '@base-ui/utils/useIsoLayoutEffect';
import { useRefWithInit } from '@base-ui/utils/useRefWithInit';
import { useAdapter } from '@mui/x-scheduler-headless/use-adapter';
import { EventTimelinePremiumStore } from "./EventTimelinePremiumStore.mjs";
export function useEventTimelinePremium(parameters) {
  const adapter = useAdapter(parameters.dateLocale);
  const store = useRefWithInit(() => new EventTimelinePremiumStore(parameters, adapter)).current;
  useIsoLayoutEffect(() => store.updateStateFromParameters(parameters, adapter), [store, adapter, parameters]);
  useOnMount(store.disposeEffect);
  return store;
}